import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgArrowRightFromBracketRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.752 19.034a.84.84 0 0 1-.844.844H6.376A3.376 3.376 0 0 1 3 16.502V7.498a3.376 3.376 0 0 1 3.376-3.376h2.532a.843.843 0 1 1 0 1.688H6.376c-.928 0-1.688.76-1.688 1.688v9.004c0 .928.76 1.688 1.688 1.688h2.532c.468 0 .844.376.844.844m11.026-7.61-4.47-4.784a.843.843 0 1 0-1.229 1.156l3.128 3.36H9.44c-.436 0-.812.38-.812.844s.378.844.812.844h8.737l-3.163 3.36a.843.843 0 0 0 .036 1.193c.197.153.404.23.58.23a.84.84 0 0 0 .615-.266l4.47-4.783a.787.787 0 0 0 .064-1.155"
    }));
export default SvgArrowRightFromBracketRegular;
